export const VideoLibraryPageTemplate = {
    slots: ['SlbVideoLibrarySlot', 'SlbBlueBottomBannerSlot'],
};
